import {
  AC_SET_LOADING,
  AC_SET_ERROR,
  AC_SET_TOOLS,
  AC_SET_MCP_SERVERS,
  AC_SET_RESOURCES,
  AC_RESET,
} from "./aiCatalogTypes";

const initialState = {
  loading: false,
  error: null,
  tools: [],
  mcpServers: [],
  resources: [],
};

export const aiCatalogReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC_SET_LOADING:
      return { ...state, loading: action.payload, error: null };
    case AC_SET_ERROR:
      return { ...state, error: action.payload, loading: false };

    case AC_SET_TOOLS:
      return { ...state, tools: action.payload };
    case AC_SET_MCP_SERVERS:
      return { ...state, mcpServers: action.payload };
    case AC_SET_RESOURCES:
      return { ...state, resources: action.payload };

    case AC_RESET:
      return initialState;

    default:
      return state;
  }
};
